export default {
    prescriptionUtil:{
        isNew(item){
            if((item.status === 2 && item.auditResult === 0) || item.remark == '99'){
                return false;
            }
            return (item.payStatus === -1 || item.payStatus === 0 || item.payStatus === 2)
        },
        isPaid(item){
            if((item.status === 2 && item.auditResult === 0) || item.remark == '99'){
                return false;
            }
            return item.payStatus === 1;
        },
        isExpired(item){
            if(item.status === 0 || (item.status === 2 && item.auditResult === 0) || item.remark == '99'){
                return true;
            }
            return item.payStatus === 99;
        },
    },
}